import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

/**
 * Provides a mapping of FilterMatchMode values to translated labels for DataTable filter menus.
 * Also provides helpers for context-appropriate match mode lists.
 */
export function useFilterMatchModeOptions() {
    const { t } = useI18n();

    const matchModeOptions = computed(() => [
        { label: t('datatable.matchMode.startsWith'), value: 'startsWith' },
        { label: t('datatable.matchMode.contains'), value: 'contains' },
        { label: t('datatable.matchMode.notContains'), value: 'notContains' },
        { label: t('datatable.matchMode.endsWith'), value: 'endsWith' },
        { label: t('datatable.matchMode.equals'), value: 'equals' },
        { label: t('datatable.matchMode.notEquals'), value: 'notEquals' },
        { label: t('datatable.matchMode.in'), value: 'in' },
        { label: t('datatable.matchMode.lessThan'), value: 'lessThan' },
        { label: t('datatable.matchMode.lessThanOrEqual'), value: 'lessThanOrEqual' },
        { label: t('datatable.matchMode.greaterThan'), value: 'greaterThan' },
        { label: t('datatable.matchMode.greaterThanOrEqual'), value: 'greaterThanOrEqual' },
        { label: t('datatable.matchMode.between'), value: 'between' },
        { label: t('datatable.matchMode.dateIs'), value: 'dateIs' },
        { label: t('datatable.matchMode.dateIsNot'), value: 'dateIsNot' },
        { label: t('datatable.matchMode.dateBefore'), value: 'dateBefore' },
        { label: t('datatable.matchMode.dateAfter'), value: 'dateAfter' }
    ]);

    const textMatchModeOptions = computed(() => matchModeOptions.value.filter(option => [
        'startsWith', 'contains', 'notContains', 'endsWith', 'equals', 'notEquals'
    ].includes(option.value)));

    const selectMatchModeOptions = computed(() => matchModeOptions.value.filter(option => [
        'equals', 'notEquals', 'in'
    ].includes(option.value)));

    const numberMatchModeOptions = computed(() => matchModeOptions.value.filter(option => [
        'equals', 'notEquals', 'lessThan', 'lessThanOrEqual', 'greaterThan', 'greaterThanOrEqual', 'between'
    ].includes(option.value)));

    const dateMatchModeOptions = computed(() => matchModeOptions.value.filter(option => [
        'dateIs', 'dateIsNot', 'dateBefore', 'dateAfter', 'between'
    ].includes(option.value)));

    return {
        matchModeOptions,
        textMatchModeOptions,
        selectMatchModeOptions,
        numberMatchModeOptions,
        dateMatchModeOptions
    };
}
